import React, { useContext, useEffect, useRef } from 'react';
import { setActiveTab } from '../../../actions/pricing';
import PricingContext from '../../../context/pricing';
import { dataLayerPush } from '../../../utils';
import { StyledTabGrid, StyledTab } from './styles';

const Tabs = () => {
  const { state, dispatch, sgPricingVersion } = useContext(PricingContext);

  const firstUpdate = useRef(true);
  useEffect(() => {
    if (
      typeof window === 'undefined' ||
      !window.dataLayer ||
      firstUpdate.current
    ) {
      firstUpdate.current = false;
      return;
    }

    dataLayerPush({
      event: 'pricingFunnel',
      eventAction: 'select_tab',
      pricingVersion: sgPricingVersion,
      tabClicked: state.activeTab,
    });
  }, [state.activeTab]);

  return (
    <StyledTabGrid role="tablist">
      <StyledTab
        onClick={() => setActiveTab('e', dispatch)}
        role="tab"
        aria-selected={state.activeTab === 'e'}
        aria-controls="ei-panel"
        id="ei-tab"
        data-testid="ei-tab"
      >
        <h3>For Developers</h3>
        <p>Integrate email into your app or website.</p>
      </StyledTab>
      <StyledTab
        onClick={() => setActiveTab('mc', dispatch)}
        role="tab"
        aria-selected={state.activeTab === 'mc'}
        aria-controls="mc-panel"
        id="mc-tab"
        data-testid="mc-tab"
      >
        <h3>For Marketers</h3>
        <p>Design and send email marketing campaigns and automations.</p>
      </StyledTab>
    </StyledTabGrid>
  );
};

export default Tabs;
